export default __webpack_public_path__ + "static/media/Headshot-7.8aa0d238.jpg";